import type { SVGProps } from 'react';

const SvgArrowButtonRight = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <path
      fill={props.color}
      d="M16 0C7.16 0 0 7.16 0 16s7.16 16 16 16 16-7.16 16-16S24.84 0 16 0Zm5.38 16.71-4.67 4.67c-.2.2-.45.29-.71.29s-.51-.1-.71-.29a.996.996 0 0 1 0-1.41l2.96-2.96h-6.93c-.55 0-1-.45-1-1s.45-1 1-1h6.93l-2.96-2.96a.996.996 0 1 1 1.41-1.41l4.67 4.67c.39.39.39 1.02 0 1.41Z"
    />
  </svg>
);

export default SvgArrowButtonRight;
